import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import compact from 'lodash/compact';
import register from 'preact-custom-element';
import config from './config';
import Entrypoint from './pages/entrypoint';
/**
 * The root web component
 * - Registers the recycling-locator custom element
 * - Renders the Preact app within the shadow DOM for style encapsulation
 * - Provides global styles
 */
export default function RecyclingLocator({ locale, variant = 'widget', basename = '/', path, publicPath = config.publicPath, theme = 'green', }) {
    const classes = compact([
        `recycling-locator-variant-${variant}`,
        `theme-preset-${theme}`,
        config.testMode ? 'recycling-locator-test-mode' : undefined,
    ]).join(' ');
    return (_jsxs(_Fragment, { children: [_jsx("link", { rel: "stylesheet", href: `${publicPath}styles.css` }), _jsx("article", { className: classes, children: _jsx(Entrypoint, { locale: locale, variant: variant, basename: basename, path: path, publicPath: publicPath }) })] }));
}
register(RecyclingLocator, 'recycling-locator', ['locale', 'variant', 'basename', 'path', 'public-path', 'theme'], {
    shadow: true,
});
